// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FDS4","importantInfo":"styles_importantInfo__2lvoU"};